var _defs, _rect, _rect2, _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1716(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1716",
    "data-name": "Group 1716",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75.132,
    height: 27.625,
    viewBox: "0 0 75.132 27.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1130",
    "data-name": "Rectangle 1130",
    width: 75.132,
    height: 27.625,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1128",
    "data-name": "Rectangle 1128",
    width: 61.039,
    height: 20.731,
    transform: "translate(0 6.893)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1129",
    "data-name": "Rectangle 1129",
    width: 60.428,
    height: 20.12,
    transform: "translate(0.306 7.199)",
    fill: "#061836"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14766",
    "data-name": "Path 14766",
    d: "M27.941,72.259V84.451H30.88l0-7.548,4.354,7.555,2.9-.008,0-12.191H35.163l-.007,7.107-4.171-7.109Z",
    transform: "translate(-23.672 -61.22)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14767",
    "data-name": "Path 14767",
    d: "M105.81,72.238l-.012,12.2h9.518l0-2.677h-6.487l0-2.458,5.689,0V76.721h-5.689V74.929l6.2.012v-2.7Z",
    transform: "translate(-89.636 -61.204)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14768",
    "data-name": "Path 14768",
    d: "M171.91,72.238l3.457,12.2,3.07,0,1.6-7.842,1.651,7.845,2.747,0,3.484-12.195-3.122,0-1.677,7.181-1.471-7.178-3.263,0-1.394,6.784-1.574-6.784Z",
    transform: "translate(-145.65 -61.204)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1715",
    "data-name": "Group 1715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1714",
    "data-name": "Group 1714",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14769",
    "data-name": "Path 14769",
    d: "M284.407,74.275s.4-1.516-1.987-1.751c-1.638-.162-1.975.987-1.728,1.42.5.881,4.282.885,6.088,2.4,1.552,1.307,1.18,4.3-.464,5.4a7.652,7.652,0,0,1-6.436.473,3.8,3.8,0,0,1-2.309-3.965h2.915s-.156,1.877,2.141,1.88c2.4,0,2.407-1.256,1.909-1.765-.552-.564-5.077-.755-6.32-2.635a3.672,3.672,0,0,1,1.264-5.1c2.209-1.328,5.488-.676,6.681.563a3.957,3.957,0,0,1,1.212,3.083Z",
    transform: "translate(-235.147 -59.221)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14770",
    "data-name": "Path 14770",
    d: "M355.923,0h20.763l-.014,20.722H355.937Z",
    transform: "translate(-301.553 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14771",
    "data-name": "Path 14771",
    d: "M357.923,2h20.152l-.013,20.111H357.936Z",
    transform: "translate(-303.248 -1.694)",
    fill: "#ec2027",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14772",
    "data-name": "Path 14772",
    d: "M371.364,28.064h4.9V40.545h-2.915v-9.6h-1.988Z",
    transform: "translate(-314.636 -23.777)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14773",
    "data-name": "Path 14773",
    d: "M418.516,32.513a2.708,2.708,0,0,0,1.263-2.737c-.224-2.1-1.988-3.153-4.042-3.172a3.746,3.746,0,0,0-3.953,3.088,2.75,2.75,0,0,0,1.274,2.818,3.615,3.615,0,0,0-1.7,3.471,4.32,4.32,0,0,0,4.467,3.546,4.263,4.263,0,0,0,4.364-3.518,3.164,3.164,0,0,0-1.669-3.5m-2.7-3.432a1.162,1.162,0,0,1,1.217,1.217,1.246,1.246,0,0,1-1.217,1.274,1.218,1.218,0,0,1-1.246-1.287,1.242,1.242,0,0,1,1.246-1.2m.029,7.593a1.447,1.447,0,0,1-1.443-1.469,1.367,1.367,0,0,1,1.432-1.432,1.451,1.451,0,0,1,.011,2.9",
    transform: "translate(-348.497 -22.54)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1716);
export default __webpack_public_path__ + "static/media/Group 1716.ecf5cc21e98042ee0eebf849ae33feaf.svg";
export { ForwardRef as ReactComponent };